import { Fnv1a, HASH_PART_COUNT, hashPlain } from '@hf/shared';
import type { SimState } from './state';

const hasher = new Fnv1a();

/**
 * 32-bit FNV-1a hash over EVERY field of the state (float64 bits, insertion order). Used for desync detection
 * (exchanged every HASH_INTERVAL_TICKS) and determinism tests. Not for the per-tick hot path.
 */
export const hashState = (s: SimState): number => hashPlain(s, hasher.reset());

/**
 * Per-section hashes for desync diagnostics (HASH_DETAIL packet), written into `out` in HASH_PART_NAMES order:
 *   [0] prng + tick + hitStop + version + config  [1] players[0]  [2] players[1]  [3] ball  [4] rules  [5] camera
 * Comparing two peers' parts localizes the divergence. Not for the hot path.
 */
export const hashStateParts = (s: SimState, out: Uint32Array | number[]): void => {
  if (out.length < HASH_PART_COUNT) throw new RangeError(`hashStateParts needs ${HASH_PART_COUNT} slots`);
  hasher.reset().u32(s.version).num(s.tick).num(s.hitStop);
  hashPlain(s.prng, hasher);
  out[0] = hashPlain(s.config, hasher);
  out[1] = hashPlain(s.players[0], hasher.reset());
  out[2] = hashPlain(s.players[1], hasher.reset());
  out[3] = hashPlain(s.ball, hasher.reset());
  out[4] = hashPlain(s.rules, hasher.reset());
  out[5] = hashPlain(s.camera, hasher.reset());
};
